import React from "react";
import { RenderNumber } from "Utils/renderField/renderReadField";
import Badge from "Utils/Badge/Badge";
import { TIPOS_DESTINO_BODEGA_PT } from "../../../../../../../utility/constants";
import { formatPalletLabel } from "../../../../ProduccionV2/helpers/formatPallet";

export const DetallesTable = ({ salidaDetalle }) => {
    const detalles =
        salidaDetalle && salidaDetalle.detalles ? salidaDetalle.detalles : [];

    if (detalles.length === 0) return null;

    const esReclasificacion =
        salidaDetalle &&
        salidaDetalle.tipo_destino === TIPOS_DESTINO_BODEGA_PT.RECLASIFICACION;

    const esReproceso =
        salidaDetalle &&
        salidaDetalle.tipo_destino === TIPOS_DESTINO_BODEGA_PT.REPROCESO;

    return (
        <React.Fragment>
            <h6 className="text-black mt-3">Pacas despachadas</h6>
            <div className="new-table-wrapper boleta-salida__table-wrapper mt-2">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>PALLET</th>
                            <th>PRODUCTO</th>
                            <th>CONFORME</th>
                            <th>PACAS</th>
                            {esReclasificacion && <th>TARJETA</th>}
                            {esReproceso && <th>ALMACÉN DESTINO</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {detalles.length === 0 && (
                            <tr>
                                <td
                                    colSpan={
                                        esReclasificacion || esReproceso ? 5 : 4
                                    }
                                    className="text-center"
                                >
                                    Sin detalles
                                </td>
                            </tr>
                        )}
                        {detalles.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center text-nowrap">
                                        {formatPalletLabel(
                                            item.pallet_numero,
                                            item.identificador_fisico,
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap boleta-salida__table-ellipsis-cell">
                                        {item.producto || "N/A"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.es_conforme_bodega ? "Sí" : "No"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={item.pacas}
                                            decimalScale={0}
                                        />
                                    </td>
                                    {esReclasificacion && (
                                        <td className="text-center text-nowrap">
                                            <Badge
                                                text={`Amarilla - ${item.tarjeta_salida}`}
                                                variant="warning"
                                            />
                                        </td>
                                    )}
                                    {esReproceso && (
                                        <td className="text-center text-nowrap">
                                            {item.bodega_destino_nombre ||
                                                "N/A"}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
